/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tab_ProductsInputs */

const en_shop_tab_products = /** @type {(inputs: Shop_Tab_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products`)
};

const pl_shop_tab_products = /** @type {(inputs: Shop_Tab_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkty`)
};

/**
* | output |
* | --- |
* | "Products" |
*
* @param {Shop_Tab_ProductsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_tab_products = /** @type {((inputs?: Shop_Tab_ProductsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tab_ProductsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_tab_products(inputs)
	return en_shop_tab_products(inputs)
});